import { ButtonContent } from './ButtonContent'
import { ButtonIcon } from './ButtonIcon'
import { ButtonRoot } from './ButtonRoot'

export const Button = {
  Root: ButtonRoot,
  Content: ButtonContent,
  Icon: ButtonIcon,
}
